import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { mapActions, viewActions } from '../state/actions';
import { LAYERS } from 'shared/src/constants/layers';
import { prokatSoilSampleService } from '../services/prokatSoilSampleService';
import { VIEWS } from 'shared';

class SoilSamplingController extends React.Component {
    componentDidMount() {
        return this.getData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            this.props.match.params.meparCode !== prevProps.match.params.meparCode ||
            this.props.location.search !== prevProps.location.search
        ) {
            return this.getData();
        }
    }

    async getData() {
        const {
            match: { params },
        } = this.props;

        const { mepar } = await prokatSoilSampleService.getMepar(params.meparCode);

        this.props.dispatch(viewActions.setInfoPanelState({ open: false }));
        this.props.dispatch(viewActions.setViewState({ view: VIEWS.PROGRESS }));

        this.props.dispatch(mapActions.resetLayers());

        this.props.dispatch(
            mapActions.updateLayer({
                type: LAYERS.TYPES.COUNTRY,
                visible: true,
                fittingLayer: false,
            })
        );

        this.props.dispatch(
            mapActions.updateLayer({
                type: LAYERS.TYPES.PROKAT_SOIL_SAMPLE_MEPAR,
                mepar,
                fittingLayer: true,
                visible: true,
            })
        );
    }

    render() {
        return null;
    }
}

export default connect()(withRouter(SoilSamplingController));
